import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { frenchTypoPostProcessor } from "@/utils/frenchTypo";

const fallbackLng = ["en"];

const LANG_TO_CODE = {
  english: 'en', french: 'fr', german: 'de',
  spanish: 'es', italian: 'it', russian: 'ru',
  arabic: 'ar',
  // also accept ISO codes directly
  en: 'en', fr: 'fr', de: 'de',
  es: 'es', it: 'it', ru: 'ru',
  ar: 'ar',
};

const getRestaurantLangCode = () => {
  try {
    const data = JSON.parse(localStorage.getItem('restaurant_data') || '{}');
    const lang = data?.language;
    if (!lang) {
      console.log('[i18n] No restaurant language found in localStorage, using browser/fallback language.');
      return null;
    }
    const code = lang ? (LANG_TO_CODE[lang.toLowerCase()] || null) : null;
    if (code) {
      console.log(`[i18n] Restaurant language: "${lang}" → locale: "${code}"`);
    } else {
      console.warn(`[i18n] Unknown restaurant language: "${lang}", falling back to default. Supported values: ${Object.keys(LANG_TO_CODE).join(', ')}`);
    }
    return code;
  } catch (e) {
    console.error('[i18n] Failed to read restaurant_data from localStorage:', e);
    return null;
  }
};

// La langue du restaurant est un DÉFAUT, pas une contrainte. Elle était imposée à
// chaque chargement : un gérant allemand ou espagnol pouvait choisir sa langue dans
// le sélecteur, le rafraîchissement suivant le renvoyait au français configuré sur
// l'établissement. Dès que la personne a fait un choix, ce choix gagne.
const storedChoice = (() => {
  try {
    const v = localStorage.getItem('i18nextLng');
    return v && LANG_TO_CODE[v.slice(0, 2).toLowerCase()] ? v.slice(0, 2).toLowerCase() : null;
  } catch {
    return null;
  }
})();

const initialLng = storedChoice || getRestaurantLangCode();
if (storedChoice) {
  console.log(`[i18n] Initializing with the language chosen by the user: "${storedChoice}"`);
} else if (initialLng) {
  console.log(`[i18n] Initializing with restaurant locale: "${initialLng}"`);
} else {
  console.log('[i18n] Initializing with browser/fallback locale.');
}

i18n
  .use(HttpBackend) // use i18next-http-backend instead of i18next-xhr-backend
  .use(LanguageDetector) // detects the current language
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(frenchTypoPostProcessor) // « 0,5 jour », « Pourquoi ? » in French (QA 13/10 evening)
  .init({
    fallbackLng, // default language
    postProcess: ['frenchTypo'],
    ...(initialLng ? { lng: initialLng } : {}),
    detection: {
      checkWhitelist: true, // options for language detection : https://www.i18next.com/overview/configuration-options#detection
      // « fr-FR », « ar-TN » from the browser → « fr », « ar »: the language every screen compares with
      // (the flag, the right-to-left switch). It was kept whole, so a French page showed the British flag (QA 31/10 #20).
      convertDetectedLanguage: (lng) => String(lng || '').slice(0, 2).toLowerCase(),
    },
    debug: false,
    interpolation: {
      escapeValue: false, // no need for react. it escapes by default
    },
    backend: {
      // configuration options for i18next-http-backend
      loadPath: '/locales/{{lng}}/{{ns}}.json' // adjust the path to your translation files
    }
  });

export const LANG_CODE_MAP = LANG_TO_CODE;

export default i18n;
